<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class="flex md12 sm12 xs12">
            <va-button flat disabled color="gray" >查看服务：</va-button>
            <va-popover message="仅限超管" placement="top">
              <va-button outline color="primary" @click="$router.push({ name: 'listLoginInfo', query: {userUid: $route.params.uid}})">登录账号</va-button>
            </va-popover>
            <va-button outline color="primary"  @click="$router.push({ name: 'listAppliedConsulting', query: {userUid: $route.params.uid}})">报名的咨询</va-button>
            <va-button outline color="primary"  @click="$router.push({ name: 'listAppliedCourse', query: {userUid: $route.params.uid}})" >报名的课程</va-button>
<!--            <va-button outline  color="primary" @click="$router.push({ name: 'listAppliedJob', query: {userUid: $route.params.uid}})" >投递的岗位</va-button>-->
            <va-button outline color="primary" @click="$router.push({ name: 'listComment', query: {fromUid: $route.params.uid}})">给导师的评论</va-button>
            <va-button outline color="primary" @click="$router.push({ name: 'listVirtualMoneyRecord', query: {uid: $route.params.uid}})">积分记录</va-button>
          </div>
          <div class='flex md3 sm6 xs12'>
            <va-input
              v-model='insertData.uid'
              v-show="showUid"
              label='uid'
              disabled
            />
          </div>
          <div class="flex md3 sm6 xs12">
            <va-input
              v-model="insertData.nickname"
              label="姓名"
              disabled
            />
          </div>
          <div class="flex md3 sm6 xs12">
            <va-input
              label="用户类型"
              v-model="insertData.userType"
              disabled
            />
          </div>
          <div class="flex md3 sm6 xs12">
            <va-input
              label="当前积分"
              v-model="points"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              label="技能"
              v-model="insertData.skill"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              v-model="insertData.briefInfo"
              label="一句话介绍自己"
              disabled
            />
          </div>
          <div class="flex md12 sm6 xs12">
            <va-input
              type="textarea"
              v-model="insertData.info"
              label="一段话描述自己"
              disabled
            />
          </div>
          <div class='flex md12 sm6 xs12' v-show="insertData.avatar.length!==0">
            <va-card
              overlay
              :image='insertData.avatar'
              class="va-card-image"
              title="头像"
            >
            </va-card>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-tree-category isOpen label="职业背景">
              <va-tree-node
                v-for="career in careerBackgrounds"
                :key="career.title"
              >
                <div class="flex row align--center">
                  <va-input v-model="career.title" disabled class="mb-0"/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>
          <div class="flex md6 sm6 xs12">
            <va-tree-category isOpen label="教育背景">
              <va-tree-node
                v-for="education in educationBackgrounds"
                :key="education.title"
              >
                <div class="flex row align--center">
                  <va-input v-model="education.title" disabled class="mb-0"/>
                </div>
              </va-tree-node>
            </va-tree-category>
          </div>

        </div>
        <div class="row justify--center">
          <div class="flex md2 " v-show="showChangeButton">
            <va-button class="ma-0 row " color="info" slot="trigger" @click="upgradeToHonoredGuestModal = true" :disabled="!submitButtonStatus" >
              升级成为嘉宾
            </va-button>
          </div>
          <div class="flex md2 " v-show="showChangeButton">
            <va-button class="ma-0 row " color="info" slot="trigger" @click="downgradeToCommonUserModal = true" :disabled="!submitButtonStatus">
              降级为普通用户
            </va-button>
          </div>
          <div class="flex mb-2 justify--center">
            <va-button color="gray" slot="trigger" @click="$router.push({ name: 'listUser'})" :disabled="!submitButtonStatus">
              返回
            </va-button>
          </div>
        </div>
        <va-modal
          v-model="upgradeToHonoredGuestModal"
          title="成为嘉宾"
          okText="提交"
          position="center"
          message="请再次确认是否将用户升级为嘉宾？"
          @ok="confirmUpgradeToHonoredGuest"
        />
        <va-modal
          v-model="downgradeToCommonUserModal"
          title="更改成为嘉宾"
          okText="提交"
          position="center"
          message="请再次确认是否要将嘉宾降级为用户？"
          @ok="confirmDowngradeToCommonUser"
        />
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import userApi from '../../api/user'
import { copyObject } from '@/utils/common'
import { USER_TYPES } from '@/utils/constants'
import virtualMoneyApi from '@/api/virtualMoney'

export default {
  data () {
    return {
      insertData: {
        id: null,
        uid: '',
        nickname: '',
        info: '',
        briefInfo: '',
        avatar: '',
        avatarArr: [],
        skill: '',
        userType: null,
      },
      message: ['可以更改'],
      educationBackgrounds: {},
      careerBackgrounds: {},
      showUid: false,
      showChangeButton: false,
      upgradeToHonoredGuestModal: false,
      downgradeToCommonUserModal: false,
      title: '',
      submitButtonStatus: true,
      points: 0,

    }
  },
  created () {
    this.getUser()
  },
  computed: {
    formReady () {
      return true
    },
  },
  methods: {
    getUser () {
      const params = this.$route.params
      if (params.uid != null) {
        this.showUid = true
        this.title = '查看用户信息'
        // 通过id获取详情
        userApi.getUser(params.uid).then(response => {
          copyObject(response.user, this.insertData)
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('careerBackgrounds')) {
            this.careerBackgrounds = response.careerBackgrounds
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.hasOwnProperty('educationBackgrounds')) {
            this.educationBackgrounds = response.educationBackgrounds
          }
          // eslint-disable-next-line no-prototype-builtins
          if (response.user.hasOwnProperty('userType')) {
            USER_TYPES.map(x => {
              if (response.user.userType === x.CODE) {
                this.insertData.userType = x.TEXT
                this.showChangeButton = x.MODIFY
              }
            })
          }
          this.getVirtualMoney()
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    getVirtualMoney() {
      if (this.insertData.uid === '') {
        return
      }
      virtualMoneyApi.getUserVirtualMoney(this.insertData.uid).then(response => {
        this.points = response.userVirtualMoney.points
      }).catch(error => {
        console.log(error.msg)
      })
    },
    updateUserType (userType) {
      this.changeButtonStatus(false)
      const data = {
        userType: userType,
      }
      userApi.updateUserType(this.insertData.uid, data).then(response => {
        if (response.success === true) {
          this.getUser()
          this.showToast('更新用户类型成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.changeButtonStatus(true)
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
        this.changeButtonStatus(true)
      })
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
    confirmUpgradeToHonoredGuest () {
      this.updateUserType(3)
      this.upgradeToHonoredGuestModal = false
    },
    confirmDowngradeToCommonUser () {
      this.updateUserType(4)
      this.downgradeToCommonUserModal = false
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
